import {
  Route,
  Routes,
  Outlet,
  Link,
  useMatch,
  useResolvedPath,
  Navigate,
} from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './quickActions.module.scss';
import QuickActionCategories from './QuickActionCategories';
import QuickActionsList from './QuickActionsList';
import QuickActionCategoryForm from './QuickActionCategoryForm';
import QuickActionForm from './QuickActionForm';
import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';

const QUICK_ACTIONS_SUBTABS = [
  {
    key: 'categories',
    to: '/dashboard/quick-actions/categories',
    name: 'Categories',
  },
  {key: 'actions', to: '/dashboard/quick-actions/actions', name: 'Actions'},
];

const QuickActionRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<QuickActionsLayout />}>
        <Route index element={<Navigate to="categories" replace />} />
        <Route path="categories" element={<QuickActionCategories />} />
        <Route path="categories/new" element={<QuickActionCategoryForm />} />
        <Route
          path="categories/:id/edit"
          element={<QuickActionCategoryForm />}
        />
        <Route path="actions" element={<QuickActionsList />} />
        <Route path="actions/new" element={<QuickActionForm />} />
        <Route path="actions/:id/edit" element={<QuickActionForm />} />
      </Route>
    </Routes>
  );
};

const QuickActionsLayout = () => {
  const {visibleSubTabs} = useVisibleSubTabs(
    NavTabsEnum.QuickActions,
    QUICK_ACTIONS_SUBTABS,
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Quick Actions Shortcuts</h1>
      </div>
      <section className={styles.section}>
        <nav className={styles['tab-toggler']}>
          {visibleSubTabs.map(tab => (
            <CustomLink key={tab.key} to={tab.to} name={tab.name} />
          ))}
        </nav>
      </section>
      <section>
        <Outlet />
      </section>
    </div>
  );
};

const CustomLink = ({to, name}) => {
  const resolved = useResolvedPath(to);
  const match = useMatch({path: resolved.pathname, end: true});
  const cx = classNames.bind(styles);

  return (
    <Link className={cx('nav-link', match ? 'active-toggle' : '')} to={to}>
      <span>{name}</span>
    </Link>
  );
};

export default QuickActionRoutes;
